import {booleanAttribute, ChangeDetectionStrategy, Component, input} from "@angular/core";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {FormaterPlainDatePipe} from "felles-ng2/pipes/FormaterPlainDatePipe";
import {MatListItemLine, MatListItemTitle, MatListOption, MatSelectionList} from "@angular/material/list";
import {TranslateModule} from "@ngx-translate/core";
import {ZonedDateTimeSomPlainDatePipe} from "felles-ng2/pipes/ZonedDateTimeSomPlainDatePipe";
import {FormControl, ReactiveFormsModule} from "@angular/forms";
import {SpørreundersøkelseEnkelMedBehandlingerModell} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {FeltValidatorer} from "felles-ng2/infrastruktur/angular/feltValidatorer";
import {MatTooltip} from "@angular/material/tooltip";

const debug = initDebugger('VelgSpørreundersøkelseKomponent');

type SkjemaType = ReturnType<typeof VelgSpørreundersøkelseKomponent.opprettSkjema>;

/**
 * Lar bruker velge spørreundersøkelser fra en liste over undersøkelser
 */
@Component({
    selector: 'velg-spoerreundersoekelse',
    templateUrl: 'velg-spørreundersøkelse.html',
    styleUrl: 'velg-spørreundersøkelse.scss',
    imports: [
        FormaterPlainDatePipe,
        MatListItemLine,
        MatListItemTitle,
        MatListOption,
        MatSelectionList,
        TranslateModule,
        ZonedDateTimeSomPlainDatePipe,
        ReactiveFormsModule,
        MatTooltip
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class VelgSpørreundersøkelseKomponent {

    static opprettSkjema() {
        return new FormControl<SpørreundersøkelseEnkelMedBehandlingerModell[]>([], {validators: FeltValidatorer.ikkeTomListe});
    }

    kontroller = input.required<SkjemaType>();
    tilgjengeligeUndersoekelser = input.required<SpørreundersøkelseEnkelMedBehandlingerModell[]>();
    tillatVelgFlere = input(false, {transform: booleanAttribute});
    ariaLabel = input<string | null>(null);
    ariaLabelledBy = input<string | null>(null);
}

